import { useContext } from 'react';
import { faFilterList } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FilterContext } from 'components/filter/filters-next/FilterContext';
import { FilterListItemButton } from 'components/filter/filters-next/FilterListItemButton';
import { FilterProviderContext } from 'components/filter/filters-next/FilterProvider';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { useUpdateFiltersByResource } from 'components/filter/useUpdateFiltersByResource';
import { v4 as uuid } from 'uuid';

const AddGroupButton = () => {
    const { cacheKey } = useContext(FilterProviderContext);
    const { currentGroup } = useFiltersByKey(cacheKey);
    const updateFilters = useUpdateFiltersByResource();
    const { setIsOpen } = useContext(FilterContext);

    return (
        <FilterListItemButton
            onClick={() => {
                updateFilters({
                    id: uuid(),
                    outerOperator: currentGroup?.outerOperator ?? 'and',
                    innerOperator: 'and',
                    filters: [],
                });
                setIsOpen(false);
            }}
        >
            <div
                className={'flex size-4 items-center justify-center [&>svg]:h-full [&>svg]:w-full'}
            >
                <FontAwesomeIcon icon={faFilterList} />
            </div>
            Add filter group
        </FilterListItemButton>
    );
};

export { AddGroupButton };
